module.exports = __webpack_public_path__ + "img/mile2-m@1.d79df62f.webp";